@if (sakmodeller.length > 0) {

  <div class="antall-valgt" [ngClass]="{'antall-valgt__ingen':antallValgt() == 0}">
    <span>
      {{ antallValgt() }}/{{ sakmodeller.length }} {{ "valgt"|translate }}
    </span>
  </div>

  <fieldset>
    <table class="e2e_malsaker">
      <tr class="valgt-tittelrad" matTooltip="{{'Velg alle eller ingen saker'|translate}}">
        <th class="valgt"><mat-checkbox (click)="endreAlle()" [indeterminate]="!alleValgt() && !ingenValgt()" [checked]="alleValgt()" class="e2e-velgallesaker"/></th>
        <th colspan="2" (click)="endreAlle()" class="e2e-velgallesaker">
          {{ "Inkluder saker fra møtemalen"|translate }}
        </th>
      </tr>
      @for (modell of sakmodeller; track modell.sak.id; let indeks = $index) {
        <tr (click)="modell.kontroller.setValue(!modell.kontroller.value)" [ngClass]="{'ekspandert': modell.erEkspandert}" class="sak e2e-sak">
          <td class="valgt"><mat-checkbox [checked]="modell.kontroller.value" class="e2e-valgt"/></td>
          <td>
            <div class="tittel e2e-tittel"> {{ modell.sak.tittel }}</div>
            <div class="beskrivelse e2e-saksbeskrivelse"><html-formatert [innhold]="modell.sak.beskrivelse"/></div>
          </td>
          <td class="ekspander">
            <button (click)="modell.erEkspandert = !modell.erEkspandert; $event.stopPropagation()" mat-icon-button aria-label="expand row" class="mat-medium-icon-button" data-testid="ekspander">
              @if (modell.erEkspandert) {
                <mat-icon>keyboard_arrow_up</mat-icon>
              } @else {
                <mat-icon>keyboard_arrow_down</mat-icon>
              }
            </button>
          </td>
        </tr>
      }
    </table>
  </fieldset>

} @else {

  <tips class="e2e-ingen-saker-tips">
    <span>{{ "Møtemalen inneholder ingen saker, rediger møtemalen for å legge til standard saker."|translate }}</span>
  </tips>
}
